import { SVGFC } from '@repo/toolkit/types'

const OpenEyeIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.8851 11.8533C20.7243 11.6141 16.8929 5.99707 11.9994 5.99707C7.10598 5.99707 3.27436 11.6141 3.11373 11.853C2.96144 12.0799 2.96144 12.3877 3.11373 12.6146C3.27436 12.8537 7.10598 18.4707 11.9994 18.4707C16.8929 18.4707 20.7243 12.8537 20.8851 12.6148C21.0376 12.3879 21.0376 12.0799 20.8851 11.8533ZM11.9994 17.1804C8.39489 17.1804 5.27297 13.4522 4.34881 12.2335C5.27177 11.0136 8.38715 7.28744 11.9994 7.28744C15.6038 7.28744 18.7255 11.0149 19.6501 12.2343C18.7271 13.4542 15.6117 17.1804 11.9994 17.1804Z"
        fill={color}
      />
      <path
        d="M12.0004 8.36621C10.0372 8.36621 8.43994 10.1029 8.43994 12.2374C8.43994 14.3719 10.0372 16.1085 12.0004 16.1085C13.9636 16.1085 15.5609 14.3719 15.5609 12.2374C15.5609 10.1029 13.9636 8.36621 12.0004 8.36621ZM12.0004 14.8181C10.6915 14.8181 9.62678 13.6604 9.62678 12.2374C9.62678 10.8143 10.6916 9.65662 12.0004 9.65662C13.3092 9.65662 14.374 10.8143 14.374 12.2374C14.374 13.6604 13.3093 14.8181 12.0004 14.8181Z"
        fill={color}
      />
    </svg>
  )
}

export default OpenEyeIcon
